import { Component, OnInit, Renderer2 } from '@angular/core';
import { PaymentService } from '../payment.service';
import { PayonlineService } from '../payonline.service';
import { data } from 'jquery';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Dialog } from '@angular/cdk/dialog';
import { MatDialog } from '@angular/material/dialog';
import { AlertComponent } from 'src/app/alert/alert.component';

@Component({
  selector: 'app-pay-online-dashboard',
  templateUrl: './pay-online-dashboard.component.html',
  styleUrls: ['./pay-online-dashboard.component.scss']
})
export class PayOnlineDashboardComponent implements OnInit {
  dueAmount: any = 0;
  paymentAmount: any;
  feeHead: any;
  clientRefNo: any;
  jwt: any;
  admNo: any;
  mobile: any;
  razorPayOrderId: any;
  studentName: string;
  errorStatus:any=false;
  message: any;
  constructor(private paymentService: PaymentService, private service: PayonlineService, private spinner: NgxSpinnerService,
    private route: ActivatedRoute, private router: Router, private renderer: Renderer2,private dialog :MatDialog) { }
  ngOnInit(): void {
    const meta = this.renderer.createElement('meta');
    this.renderer.setAttribute(meta, 'name', 'viewport');
    this.renderer.setAttribute(meta, 'content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
    this.renderer.appendChild(document.head, meta);
    this.route.paramMap.subscribe(params => {
      this.jwt = params.get('jwt')!;
      this.admNo = params.get('uniref')!;
      this.mobile = params.get('mobile')!;
      this.studentName = params.get('studentName')!;
      localStorage.setItem("time", params.get('date')!)

      console.log('JWT:', this.jwt);
      console.log('Uniref:', this.admNo);
      console.log('Mobile:', this.mobile);

      localStorage.setItem('token', this.jwt); // save JWT
    });
    // this.getDueAmount('FEE')
  }
  payonline(amount: any, orderId: any) {
    this.paymentService.openRazorpay(amount, orderId,this.studentName,this.mobile, (data: any) => {
      this.paymentDetails(data);
    });



  }

  getDueAmount(feeHead: any) {
    this.spinner.show()
    this.feeHead = feeHead;
    const payload = {
      "admNo": this.admNo,
      "feeType": this.feeHead,
      "jwtToken": this.jwt
    }
    this.service.getOverallDueDetails(payload).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide()
          return;
        }
        this.dueAmount = res.dueAmount;
        this.clientRefNo = res.clientRefNo
        // console.log(res)
        this.spinner.hide()
      },
      error: (err: any) => {
        this.spinner.hide()
        this.errorStatus=true;
        this.message = err.error.description
      }
    })
  }

  createOrder() {
    // this.sendData()
    if (this.paymentAmount >= 60 && this.paymentAmount && this.paymentAmount<=this.dueAmount) {
      this.spinner.show()
      const payload = {
        "admNo": this.admNo,
        "clientRefNo": this.clientRefNo,
        "feeType": this.feeHead,
        "paidAmount": this.paymentAmount,
        "jwtToken": this.jwt
      }
      this.service.createOrderDetails(payload).subscribe({
        next: (res: any) => {
          if (!res) {
            this.spinner.hide()
            return;
          }
          this.payonline(res.paidAmount, res.orderId);
          this.spinner.hide()

        },
        error: (err: any) => {
          this.spinner.hide()
        }
      })
    }
    else {
       this.dialog.open(AlertComponent,{
          width: '800px',
          // position: { right: '20px', top: '20px' },
          data: { 
            data:"Please enter amount More than Rs 60",
            status:"Warning"
          }
        })
    }
  }

  paymentDetails(data: any) {

    if (data.status != "cancelled") {
      this.spinner.show()
      this.razorPayOrderId = data.order_id
      const payload = {
        "razorpayOrderId": data.order_id,
        "razorpayPaymentId": data.payment_id,
        "razorpaySignature": data.signature,
        "paymentStatus": data.status,
        "jwtToken": this.jwt
      }
      console.log(payload)
      this.service.paymentDetails(payload).subscribe({
        next: (res: any) => {
          if (!res) {
            this.spinner.hide()
            return;
          }
          console.log(res)
          const data = {
            res: JSON.stringify(res),
            amount: this.paymentAmount,
            orderId: this.razorPayOrderId
          }
          this.router.navigate(['/payment/paymentResults'], { queryParams: data });
          this.spinner.hide()
        },
        error: (err: any) => {
          this.spinner.hide()
        }
      })
    }
  }


  restrictToNumbers(event: any) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '');
  }

  // sendData() {
  //   const data = 'true';
  //   (window as any).ReactNativeWebView.postMessage(JSON.stringify(data));
  // }

  getInputValue(event: any) {
    this.paymentAmount = Number(event.target.value);
    console.log(this.paymentAmount)
  }
}
